import { complement, isNil } from 'rambda';

export const isNotNil = complement(isNil);
